<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<p-fieldset>
    <ng-template pTemplate="header">{{translations.lbl_following_up}} {{translations.lbl_orders_request}}</ng-template>
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>
    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <!-- FORM -->
                    <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <!-- INPUT COORDINATION -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_coordination}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input type="text" pInputText formControlName="selectedCoordination">
                            </div>
                        </div>
                        <!-- COMBO YEARS -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_year}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-dropdown id="listYears" [options]="listYears" formControlName="selectedYear"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_year}}"
                                    optionLabel="descrip" [filter]="true" (onChange)="onChangeYear()"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </p-panel>
            </div>
        </div>
    </div>



    <!-- TABLE -->
    <p-table #dt1 [value]="listOrders" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}"
        [rowsPerPageOptions]="[10,20,50]" styleClass="p-datatable-responsive-demo" dataKey="seqId"
        [globalFilterFields]="['seqId', 'storeName', 'supplName','language','hdrStatus','maxSentDate', 'reqDate', 'maxRcvDate']"
        responsive="true">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <div>
                    <!-- EXPORT EXCEL BUTTON -->
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>
                    <!-- EXPORT PDF BUTTON -->
                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                        class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    <!-- RELOAD BUTTON -->
                    <!-- <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                pTooltip="{{translations.lbl_reload}}" tooltipPosition="bottom"></button> -->
                </div>

                <div class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value ,'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </div>
            </div>
        </ng-template>

        <!-- HEADER -->
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="seqId" tooltipPosition="top"
                    pTooltip="{{translations.lbl_number}} {{translations.lbl_order}}">{{translations.lbl_number}}
                    {{translations.lbl_order}}<p-sortIcon field="seqId"></p-sortIcon></th>
                <th pSortableColumn="storeName" tooltipPosition="top" pTooltip="{{translations.lbl_applicant}}">
                    {{translations.lbl_applicant}}<p-sortIcon field="storeName"></p-sortIcon></th>
                <th pSortableColumn="supplName" tooltipPosition="top" pTooltip="Requerido A">
                    {{translations.lbl_required}} {{translations.lbl_to}}
                    <p-sortIcon field="supplName"></p-sortIcon>
                </th>
                <th pSortableColumn="reqDate" tooltipPosition="top"
                    pTooltip="{{translations.lbl_date}} {{translations.lbl_order}}">{{translations.lbl_date}}
                    {{translations.lbl_order}}<p-sortIcon field="reqDate"></p-sortIcon></th>
                <th pSortableColumn="language" tooltipPosition="top" pTooltip="{{translations.lbl_language}}">
                    {{translations.lbl_language}}<p-sortIcon field="language"></p-sortIcon></th>
                <th pSortableColumn="hdrStatus" tooltipPosition="top" pTooltip="{{translations.lbl_status}}">
                    {{translations.lbl_status}}<p-sortIcon field="hdrStatus"></p-sortIcon></th>
                <th pSortableColumn="maxSentDate" tooltipPosition="top" pTooltip="{{translations.lbl_sent_date}}">
                    {{translations.lbl_sent_date}}<p-sortIcon field="maxSentDate"></p-sortIcon></th>
                <th pSortableColumn="maxRcvDate" tooltipPosition="top" pTooltip="{{translations.lbl_receiving_date}}">
                    {{translations.lbl_receiving_date}}<p-sortIcon field="maxRcvDate"></p-sortIcon></th>
                <th tooltipPosition="top" pTooltip="{{translations.lbl_comments}}">{{translations.lbl_comments}}
                </th>
                <th tooltipPosition="top" pTooltip="Acciones">{{translations.lbl_actions}}</th>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-order>
            <tr>
                <td><span class="p-column-title">{{translations.lbl_number}}
                        {{translations.lbl_order}}</span>{{order.orderYear}}-{{order.orderSeq}}-{{order.supplSeq}}
                </td>
                <td><span class="p-column-title">{{translations.lbl_applicant}}</span>{{order.storeName}}</td>
                <td><span class="p-column-title">{{translations.lbl_required}}
                        {{translations.lbl_to}}</span>{{order.supplName}}</td>
                <td><span class="p-column-title">{{translations.lbl_date}}
                        {{translations.lbl_order}}</span>{{order.reqDate}}</td>
                <td><span class="p-column-title">{{translations.lbl_language}}</span>{{order.language}}</td>
                <td><span class="p-column-title">{{translations.lbl_status}}</span>{{order.hdrStatus}}</td>
                <td><span class="p-column-title">{{translations.lbl_sent_date}}</span>{{order.maxSentDate}}</td>
                <td><span class="p-column-title">{{translations.lbl_receiving_date}}</span>{{order.maxRcvDate}}</td>
                <td><span class="p-column-title">{{translations.lbl_comments}}</span>{{formatComments(order)}}</td>
                <td><span class="p-column-title">{{translations.lbl_actions}}</span>
                    <button pButton pRipple type="button" icon="pi pi-comment" (click)="viewFullComment(order)"
                        *ngIf="checkCommentLength(order)" class="p-button-rounded p-button-info p-mr-2"></button>
                    <button pButton pRipple type="button" icon="pi pi-search" (click)="viewOrderDetail(order)"
                        class="p-button-rounded p-button-error p-mr-2"></button>
                </td>
            </tr>
        </ng-template>
        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_there_are}} {{listOrders != null ? listOrders.length : 0 }}
                {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</p-fieldset>

<p-dialog header="{{translations.lbl_comments}}" [(visible)]="displayModal" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p>
        {{globalUserDataForm.get('fullComments').value}}
    </p>
    <ng-template pTemplate="footer">
        <p-button (click)="displayModal=false" label="OK" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>